import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {
  ApprovalFlowStages
} from 'src/app/store/entities/instution-settings/approval-flow-stages/approval-flow-stages.model';
import {
  selectModifiedApprovalFlowStages
} from 'src/app/store/entities/instution-settings/approval-flow-stages/approval-flow-stages.selectors';
import {
  ApprovalFlowSuccessor
} from 'src/app/store/entities/instution-settings/approval-flow-successor/approval-flow-successor.model';
import {AppState} from 'src/app/store/reducers';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {
  createApprovalFlowStageSuccessorMutation,
  updateApprovalFlowStageSuccessorMutation
} from "../../../../../store/entities/instution-settings/approval-flow-stages/approval-flow-stages.actions";

@Component({
  selector: 'app-add-approval-flow-successor',
  templateUrl: './add-approval-flow-successor.component.html',
  styleUrls: ['./add-approval-flow-successor.component.scss'],
})
export class AddApprovalFlowSuccessorComponent implements OnInit {
  title: string;
  approvalFlowStagesSuccessorForm: FormGroup;

  hide: boolean = true;
  selectedData: ApprovalFlowSuccessor;
  successorStages$: Observable<ApprovalFlowStages[]>;
  stages: ApprovalFlowStages;

  constructor(
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA)
    data: { selectedData: ApprovalFlowSuccessor; stages: ApprovalFlowStages },
    private dialogRef: MatDialogRef<AddApprovalFlowSuccessorComponent>,
    private fb: FormBuilder,
  ) {
    this.selectedData = data?.selectedData;
    this.stages = data?.stages;
  }

  ngOnInit(): void {
    this.approvalFlowStagesSuccessorForm = this.fb.group({
      successorStage: [null, Validators.required],
      successorCurrentStage: [this.stages?.stageUniqueId, Validators.required],
    });

    this.successorStages$ = this.store.select(selectModifiedApprovalFlowStages);

    if (this.selectedData) {
      this.approvalFlowStagesSuccessorForm.patchValue({
        ...this.selectedData,
      });
    }
  }

  closeModal(close: boolean): void {
    if (close) {
      this.dialogRef.close();
    }
  }

  submitForm(formValue: {
    successorCurrentStage: string;
    successorStage: string;
  }) {
    // this.selectedData
    //   ? this.store.dispatch(
    //     updateApprovalFlowStageSuccessorMutation({
    //         successor: {
    //           ...formValue,
    //           successorUniqueId: this.selectedData.successorUniqueId,
    //         },
    //       })
    //     )
    //   :
      this.store.dispatch(
        createApprovalFlowStageSuccessorMutation({
            successor: formValue,
          })
        );
    this.closeModal(true);
  }
}
